import { Field, useFormikContext } from 'formik';
import { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

export const FormikRecaptcha = ({ name = 'recaptcha_response' }) => {
  const { setFieldValue, errors, validateField, submitCount } =
    useFormikContext();

  const handleSuccess = (responseToken) => {
    setFieldValue(name, responseToken);
    validateField(name);
  };

  return (
    <Field
      name={name}
      validate={(value) => {
        if (!value) {
          return __('Required');
        }
      }}
    >
      {() => (
        <RecaptchaField
          onSuccess={handleSuccess}
          error={errors?.[name]}
          submitCount={submitCount}
        />
      )}
    </Field>
  );
};

export const RecaptchaField = ({
  name = 'recaptcha_response',
  onSuccess,
  error,
  submitCount,
}) => {
  const captcha = useRef<ReCAPTCHA>(null);
  const hiddenInput = useRef<HTMLInputElement>(null);

  const validateCaptcha = () => {
    if (
      !captcha?.current?.getWidgetId ||
      !captcha.current.getWidgetId() === null
    )
      return s__('Captcha|Captcha not yet loaded');

    if (!captcha?.current?.getValue())
      return s__('Captcha|Please complete captcha');
  };

  const onChange = (value) => {
    if (hiddenInput.current) {
      hiddenInput.current.value = value;
    }

    onSuccess?.(value);
  };

  return (
    <Box flexDirection="column" data-testid="recaptcha-container">
      <Box>
        <ReCAPTCHA
          ref={captcha}
          sitekey={window.__HB_ENV__.GOOGLE_RECAPTCHA_V2_SITE_KEY}
          onChange={onChange}
        />
      </Box>

      {error && submitCount > 0 && (
        <AdditionalInformation id={`${name}-error`} type="error">
          {error}
        </AdditionalInformation>
      )}
      <Box>
        <input
          type="hidden"
          name={name}
          ref={hiddenInput}
          onChange={validateCaptcha}
          required
        />
      </Box>
    </Box>
  );
};

export default RecaptchaField;
